import { FormInput, FormSelect, FormTextArea } from "@farzoom/common-ui-components";
import { Col, Row } from "antd";
import { useFormContext } from "react-hook-form";
import { Section } from "../section";
import { useSelector } from "react-redux";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { isShowPurchase } from "@app/store/purchaseSlice";
import { FormInputDateTime } from "@app/common-ui-components/FormInputDateTime";

export const lawOptions = [
  { key: "44", value: "44-ФЗ" },
  { key: "223", value: "223-ФЗ" },
  { key: "185-615", value: "185-ФЗ/615ПП" },
  { key: "commercial", value: "Коммерческая гарантия" },
];

export const auctionTypeOptions = [
  { key: "public", value: "Открытый" },
  { key: "private", value: "Закрытый" },
];

export const PurchaseInfo = () => {
  const { control, setValue } = useFormContext<BgFormInput>();
  const { formDisabled, prefix, isStartForm } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.purchase` : "purchase") as "purchase";
  const isShowPurchaseFields = useSelector(isShowPurchase);

  if (isStartForm && !isShowPurchaseFields) return null;

  return (
    <Section title="Сведения о закупке">
      <Row gutter={[8, 8]} align="top">
        {!isStartForm && (
          <Col span={8}>
            <FormInput
              name={`${currentPrefix}.purchaseNumber`}
              control={control}
              label="Реестровый № торгов"
              placeholder="№ торгов"
              disabled
            />
          </Col>
        )}
        <Col span={8}>
          <FormInput
            name={`${currentPrefix}.marketPlace`}
            control={control}
            label="Площадка"
            placeholder="Название площадки"
            required={!formDisabled}
          />
        </Col>
        <Col span={8}>
          <FormSelect
            name={`${currentPrefix}.auctionType`}
            label="Тип аукциона"
            setValue={setValue}
            control={control}
            options={auctionTypeOptions}
            disabled={formDisabled}
            required={!formDisabled}
          />
        </Col>

        <Col span={8}>
          <FormInput
            name={`${currentPrefix}.tenderType`}
            control={control}
            label="Способ размещения"
            required={!formDisabled}
          />
        </Col>
        <Col span={8}>
          <FormInputDateTime
            name={`${currentPrefix}.tenderDate`}
            control={control}
            setValue={setValue}
            label="Дата размещения тендера"
            disabled={formDisabled}
            required={!formDisabled}
          />
        </Col>
        <Col span={8}>
          <FormSelect
            name={`${currentPrefix}.law`}
            label="Закон"
            setValue={setValue}
            control={control}
            options={lawOptions}
            disabled={formDisabled}
            required={!formDisabled}
          />
        </Col>
        <Col span={24}>
          <FormInput
            name={`${currentPrefix}.purchaseLink`}
            control={control}
            label="Ссылка на тендер в Интернете"
            placeholder="Укажите ссылку"
            required={!formDisabled}
          />
        </Col>
        <Col span={24}>
          <FormTextArea
            name={`${currentPrefix}.purchaseSubject`}
            control={control}
            label="Предмет закупки"
            required={!formDisabled}
          />
        </Col>
      </Row>
    </Section>
  );
};
